import { render, staticRenderFns } from "./SGPPermissionamentoComponent.vue?vue&type=template&id=00e4b23c"
import script from "./SGPPermissionamentoComponent.vue?vue&type=script&lang=js"
export * from "./SGPPermissionamentoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports